import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Row, Col } from 'antd'
import { compose } from 'recompose'
import _ from 'lodash'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
		}
	}
    
	render() {
		const { dashboardData } = this.props

		const todayVisitors = _.has(dashboardData, 'todayVisitors') ? dashboardData.todayVisitors : 0
		const weekVisitors = _.has(dashboardData, 'weekVisitors') ? dashboardData.weekVisitors : 0
		const monthVisitors = _.has(dashboardData, 'monthVisitors') ? dashboardData.monthVisitors : 0
		return (
			<React.Fragment>
				<Row className='dtr-dashboard-box-panel'>
					<Row style={{ textAlign: 'center' }}>
						<span 
							style={{ fontSize: '20px', fontWeight: 'bold' }}
						>TODAY VISITORS</span>
					</Row>
					<Row style={{ textAlign: 'center' }}>
						<span 
							style={{ 
								fontSize: '40px', 
								fontWeight: 'bold'
							}}
						>{todayVisitors}</span>
					</Row>
				</Row>
				<Row style={{ marginTop: 20 }} className='dtr-dashboard-box-panel'>
					<Row style={{ textAlign: 'center' }}>
						<span 
							style={{ fontSize: '20px', fontWeight: 'bold' }}
						>THIS WEEK VISITORS</span>
					</Row>
					<Row style={{ textAlign: 'center' }}>
						<span 
							style={{ 
								fontSize: '40px', 
								fontWeight: 'bold'
							}}
						>{weekVisitors}</span>
					</Row>
				</Row>
				<Row style={{ marginTop: 20 }} className='dtr-dashboard-box-panel'>
					<Row style={{ textAlign: 'center' }}>
						<span 
							style={{ fontSize: '20px', fontWeight: 'bold' }}
						>THIS MONTH VISITORS</span>
					</Row>
					<Row style={{ textAlign: 'center' }}>
						<span 
							style={{ 
								fontSize: '40px', 
								fontWeight: 'bold'
							}}
						>{monthVisitors}</span>
					</Row>
				</Row>
			</React.Fragment>
		)
	}
}

const composed = compose(
	observer
)

export default composed(Index)
